import s from './Support.module.scss';
import { Modal } from 'components/common/Modal/Modal';
import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SearchInput } from 'components/common/SearchInput';
import { useState } from 'react';
import { Button } from 'components/common/Button/Button';
import { ScrollableContainer } from 'components/common/ScrollableContainer';
import { ReactComponent as Arrow } from 'images/arrow.svg';

const icons = {
  arrow: <Arrow />,
};

const THEME_LIST = [
  {
    id: 1,
    name: 'Общие вопросы',
    questions: [
      {
        id: 1,
        name: 'Что такое «Эксперты»?',
      },
      {
        id: 2,
        name: 'Что такое «Эксперты»?',
      },
      {
        id: 3,
        name: 'Что такое «Эксперты»?',
      },
      {
        id: 4,
        name: 'Что такое «Эксперты»?',
      },
      {
        id: 5,
        name: 'Что такое «Эксперты»?',
      },
      {
        id: 6,
        name: 'Что такое «Эксперты»?',
      },
      {
        id: 7,
        name: 'Что такое «Эксперты»?',
      },
      {
        id: 8,
        name: 'Что такое «Эксперты»?',
      },
    ],
  },
  {
    id: 2,
    name: 'Аккаунт и профиль',
    questions: [
      {
        id: 1,
        name: 'Как создать аккаунт?',
      },
    ],
  },
  {
    id: 3,
    name: 'Тарифы и подписки',
    questions: [
      {
        id: 1,
        name: 'Как оплатить подписку?',
      },
    ],
  },
  {
    id: 4,
    name: 'Оплата и возврат',
    questions: [
      {
        id: 1,
        name: 'Как связаться с поддержкой?',
      },
    ],
  },
  {
    id: 5,
    name: 'Другое',
    questions: [
      {
        id: 1,
        name: 'Как удалить аккаунт?',
      },
    ],
  },
];

export const Support = () => {
  const { t } = useTranslation();
  const { closeRouteModal, goBack } =
    useOutletContext<ModalNavigationContext>();
  const navigate = useNavigate();

  const [currentTheme, setCurrentTheme] = useState<number>(THEME_LIST[0].id);
  const currentThemeQuestions =
    THEME_LIST.find((theme) => theme.id === currentTheme)?.questions ?? [];

  const handleChangeTheme = (id: number) => {
    setCurrentTheme(id);
  };

  const handleNavigateToQuestion = (id: number) => {
    navigate(`${id}`);
  };

  return (
    <Modal
      title={t('profile.support.title')}
      onClose={closeRouteModal}
      onBack={goBack}
    >
      <div className={s.container}>
        <SearchInput value='' onChange={() => {}} />

        <div className={s.themes}>
          {THEME_LIST.map((theme) => (
            <Button
              key={theme.id}
              className={s['themes__btn']}
              data-active={currentTheme === theme.id}
              isRounded={true}
              onClick={() => handleChangeTheme(theme.id)}
            >
              {theme.name}
            </Button>
          ))}
        </div>

        <ScrollableContainer scrollHeight='30rem'>
          <ul className={s.questions}>
            {currentThemeQuestions.map((question) => (
              <li
                key={question.id}
                className={s['questions__item']}
                onClick={() => handleNavigateToQuestion(question.id)}
              >
                {question.name}

                {icons.arrow}
              </li>
            ))}
          </ul>
        </ScrollableContainer>
      </div>
    </Modal>
  );
};
